<template>
  <div>
    <multiselect
      :multiple="multiselect"
      v-model="value"
      :options="options"
      @input="selectBusiness"
      :custom-label="businessLabel"
      track-by="id"
      label="name"
      :loading="isLoading"
      :internal-search="false"
      :hide-selected="true"
      @search-change="asyncFind"
      selectLabel=""
      :preserveSearch="true"
      :placeholder="$t('Businesses.Filter')"
    >
    </multiselect>
  </div>
</template>
<script>
import { businessService } from "../../_services";

export default {
  name: "BusinessSelectFilter",
  data: () => ({
    title: "BusinessSelectFilter",
    options: [],
    value: null,
    isLoading: false,
  }),
  props: {
    multiselect: Boolean,
  },
  methods: {
    selectBusiness(value, id) {
      this.$emit("selectBusiness", value);
    },

    businessLabel({ name, city }) {
      return `${name} - ${city}`;
    },
    asyncFind(query) {
      if (query.length != 0) {
        clearTimeout(this.searchTimeout); // clear existing timeout if any

        this.searchTimeout = setTimeout(() => {
          this.isLoading = true;
          let request = {
            keyword: query,
            perPage: 200,
          };

          businessService
            .filterAdmin(request)
            .then((data) => {
              this.options = [];

              data.businesses.forEach((obj) => {
                this.options.push({
                  id: obj.id,
                  name: obj.name,
                  city: obj.city,
                });
              });
            })
            .catch(() => {
              this.options = [];
            })
            .finally(() => {
              this.isLoading = false;
            });
        }, 1000);
      }
    },
  },
  mounted() {},
};
</script>
<style>
.multiselect {
  z-index: 999;
  min-width: 230px;
}

.multiselect__option--highlight {
  background-color: #48b7ff;
  outline: none;
  color: #fff;
}

.multiselect__tags {
  min-height: 20px !important;
  display: block;
  padding: 6px 40px 0 8px !important;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 14px;
}
</style>
